var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSuburbs = function SvgSuburbs(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 408.8C69.1 408.8 69.1 444.8 105.2 444.8C141.2 444.8 141.2 408.8 177.3 408.8C213.3 408.8 213.3 444.8 249.4 444.8C285.4 444.8 285.4 408.8 321.5 408.8C357.5 408.8 357.5 444.8 393.6 444.8C429.7 444.8 429.6 408.8 465.7 408.8",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M406.4 364.9V191.2L378.5 142.1",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M406.4 271.4C435.008 271.4 458.2 223.002 458.2 163.3C458.2 103.598 435.008 55.2002 406.4 55.2002C377.792 55.2002 354.6 103.598 354.6 163.3C354.6 223.002 377.792 271.4 406.4 271.4Z",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1 271.4C120.708 271.4 143.9 223.002 143.9 163.3C143.9 103.598 120.708 55.2002 92.1 55.2002C63.4917 55.2002 40.3 103.598 40.3 163.3C40.3 223.002 63.4917 271.4 92.1 271.4Z",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M395.2 171.6L425.2 109.1",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6 364.9V191.2L117.5 142.1",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.7 171.6L70.8 109.1",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 370.3H465.6",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M326.2 329.4H173.9V370.3H326.2V329.4Z",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M250 327.4C250 327.4 250 303.2 250 291.4C250 270.4 267 253.3 288.1 253.3C309.1 253.3 326.2 270.3 326.2 291.4",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M250 327.4C250 327.4 250 303.2 250 291.4C250 270.4 233 253.3 211.9 253.3C190.8 253.3 173.8 270.3 173.8 291.4",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M250 234.6C250 234.6 250 216.7 250 207.9C250 192.3 262.6 179.7 278.2 179.7C293.8 179.7 306.4 192.3 306.4 207.9",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M250 234.6C250 234.6 250 216.7 250 207.9C250 192.3 237.4 179.7 221.8 179.7C206.2 179.7 193.6 192.3 193.6 207.9",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M250 155C250 155 250 143.1 250 137.3C250 127 258.4 118.6 268.7 118.6C279 118.6 287.4 127 287.4 137.3",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M250 155C250 155 250 143.1 250 137.3C250 127 241.6 118.6 231.3 118.6C221 118.6 212.6 127 212.6 137.3",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSuburbs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/suburbs.svg";